import DepartmentFormModal from "./DepartmentFormModal";

export default DepartmentFormModal;
